import { render, staticRenderFns } from "./SPIFEfficiencyVariance.vue?vue&type=template&id=5e71a862"
import script from "./SPIFEfficiencyVariance.vue?vue&type=script&lang=js"
export * from "./SPIFEfficiencyVariance.vue?vue&type=script&lang=js"
import style0 from "./SPIFEfficiencyVariance.vue?vue&type=style&index=0&id=5e71a862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports